import React from "react"

class PageTitle extends React.Component {

    render() {
        const { title } = this.props
        return (
            <section className="page-title">
                <div className="pattern-layers">
                    <div className="layer-one" style={{ backgroundImage: "url('images/pattern-7.png')" }}></div>
                    <div className="layer-two" style={{ backgroundImage: "url('images/pattern-8.png')" }}></div>
                </div>
                <div className="auto-container">
                    <h2>{title}</h2>
                    <ul className="page-breadcrumb">
                        <li><a href="/"><span className="icon fas fa-home"></span> home</a></li>
                        <li>{title}</li>
                    </ul>
                </div>
            </section>

        )
    }

}
export default PageTitle